import { PageTypeEnum, WebsitePageType } from 'common/enums/PageTypeEnum'
import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { File04Icon } from 'src/editor/shared/icons/file-04-icon'
import { twMerge } from 'tailwind-merge'
import { PricingPageWhiteLabelIcon } from '../../icons/pricing-page-white-label-icon'

export interface PageElementProps {
  name: string
  pageType: WebsitePageType
  isActive?: boolean
  onClick?: (type: WebsitePageType) => void
  endElement?: React.ReactNode
  hasSkeleton?: boolean
}

const pageTypeIcons = {
  [PageTypeEnum.WebsiteHome]: <File04Icon className="fill-iconSecondary" />,
  [PageTypeEnum.WebsiteDefault]: <File04Icon className="fill-iconSecondary" />,
  [PageTypeEnum.WebsiteLayout]: <File04Icon className="fill-iconSecondary" />,
  [PageTypeEnum.WebsiteLogin]: <File04Icon className="fill-iconSecondary" />,
  [PageTypeEnum.WebsitePricing]: (
    <PricingPageWhiteLabelIcon className="fill-iconSecondary" />
  ),
}

export const PageElement = ({
  name,
  pageType,
  isActive,
  onClick,
  endElement,
  hasSkeleton,
}: PageElementProps) => (
  <article
    onClick={() => onClick?.(pageType)}
    className={twMerge(
      'relative flex justify-between rounded-md p-3 transition-all duration-150 hover:bg-gray-50',
      isActive && 'bg-gray-50',
      onClick && 'cursor-pointer',
    )}
  >
    {hasSkeleton && (
      <Skeleton
        containerClassName="absolute inset-0"
        className={'!leading-[inherit] h-full w-full'}
      />
    )}
    <div className="inline-flex flex-row items-center gap-1.5 [&>svg]:shrink-0">
      {pageTypeIcons[pageType]}
      <span className="wrap-anywhere text-M text-textPrimary">{name}</span>
    </div>
    {/** biome-ignore lint/a11y/noStaticElementInteractions: <explanation> */}
    <div onClick={e => e.stopPropagation()}>{endElement}</div>
  </article>
)
